import { finalRouteApi } from "./CommonApiUrl";

const liveOrderDefaultURL = {
      // finalRouteApilistApi: `${finalRouteApi}`,
      listApi: `${finalRouteApi}/Livestream-HomePage-Order/index`,
      orderApi: `${finalRouteApi}/Livestream-HomePage-Order/ordering`,
      editApi: `${finalRouteApi}/Livestream-HomePage-Order/edit`,
      updateApi: `${finalRouteApi}/Livestream-HomePage-Order/update`,
      
      enableWebSettingURL: `${finalRouteApi}/Web-Livestream-HomePage/index`,
      updateWebSettingURL: `${finalRouteApi}/Web-Livestream-HomePage/update`,
   
      enableMobileSettingURL: `${finalRouteApi}/Livestream-Mobile-HomePage/index`,
      updateMobileSettingURL: `${finalRouteApi}/Livestream-Mobile-HomePage/update`,
   
      enableTvSettingURL: `${finalRouteApi}/Livestream-TVHomePage/index`,
      updateTvSettingURL: `${finalRouteApi}/Livestream-TVHomePage/update`,

      enableSamsungSettingURL: `${finalRouteApi}/Samsung-Livestream-HomePage/index`,
      updateSamsungSettingURL: `${finalRouteApi}/Samsung-Livestream-HomePage/update`,

      enableLgSettingURL: `${finalRouteApi}/LG-Livestream-HomePage/index`,
      updateLgSettingURL: `${finalRouteApi}/LG-Livestream-HomePage/update`,
};

export { liveOrderDefaultURL };